export default {
    type: 'date',
    format: {},
    default: {
        logic: 'min',
        period: 'day'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'rolling'],
        period: ['day', 'week', 'month', 'year']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Date Last Played',
        category: ['User', 'Plays'],
        description: 'Date of the last play of the game.',
        summarise: {
            prefix: 'Last played'
        },
        unit: function(rule) {

            return rule.setting.period

        }
    },
    rules: {
        linked: [],
        legacy: ['played.last']
    }
}